import { render, staticRenderFns } from "./JapanVisaApplicationAnnouncement2025.vue?vue&type=template&id=4c7026e8&scoped=true"
import script from "./JapanVisaApplicationAnnouncement2025.vue?vue&type=script&lang=js"
export * from "./JapanVisaApplicationAnnouncement2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7026e8",
  null
  
)

export default component.exports